import React  from 'react';
import { array, bool, number, object, string } from 'prop-types';
import { Grid } from '@material-ui/core';
import CustomeTextField from 'components/UpdateUi/CustomeTextField';
import CustomeSelectNew from "components/UpdateUi/CustomeSelect.js";

const CorrespondenceAddress = ({
    sameAddress,
    inputFields,
    setPincodeCorrState,
    setDistrictCorrState,
    setVillageTownCityCorrState,
    setStateNameCorrState,
    setPostOfficeCorrState,
    setLocalityCorrState,
    setStreetCorrState,
    setHouseCorrNumberState,
    pincodeCorrState,
    houseCorrNumberState,
    streetCorrState,
    localityCorrState,
    postOfficeCorrState,
    villageTownCityCorrState,
    stateNameCorrState,
    districtCorrState,
    handleInput,
    houseNumber,
    editable,
    street,
    locality,
    postOffice,
    villageTownCity,
    stateName,
    stateList,
    district,
    pincode,
    classes,
    coresHouseNumber,
    setCoresHouseNumber,
    coresLocality,
    setCoresLocality,
    coresStreet,
    setCoresStreet,
    coresPostOffice,
    setCoresPostOffice,
    coresVillage,
    setCoresVillage,
    coresDistrict,
    setCoresDistrict,
    coresPinCode,
    setCoresPinCode,
    coresState,
    setCoresState,
    disabledScreen,
    loanStatus,
    disabledFields
}) => {
    return (
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
      <Grid container className={classes.inputFieldContainer}>
      <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
      <CustomeTextField
        label="Flat No./House No./Plot No./Building Name"
        required
        error={sameAddress ?false:houseCorrNumberState}
        value={sameAddress ? houseNumber : coresHouseNumber|| ""}
        setState={setCoresHouseNumber} 
        setError={sameAddress ? false: setHouseCorrNumberState}
        disabled={sameAddress || loanStatus ? true : !editable || (disabledFields && (houseNumber || coresHouseNumber))}
        id="house_number"
        />
    </Grid>
      <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
      <CustomeTextField
        label="Street"
        required
        error={sameAddress ?false:streetCorrState}
        value={sameAddress ? street :  coresStreet || ""}
        setState={setCoresStreet} 
        setError={sameAddress?false:setStreetCorrState}
        disabled={sameAddress || loanStatus ? true : !editable || (disabledFields && (street || coresStreet))}
        id="street"
        />
    </Grid>
      <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
      <CustomeTextField
        label="Locality"
        required
        error={sameAddress ?false:localityCorrState}
        value={sameAddress ? locality : coresLocality || ""}
        setState={setCoresLocality} 
        setError={sameAddress?false:setLocalityCorrState}
        disabled={sameAddress || loanStatus ? true : !editable  || (disabledFields && (locality || coresLocality))}
        id="locality"
        />
    </Grid>
      <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
      <CustomeTextField
        label="PostOffice"
        required
        type="alphabets"
        error={sameAddress ?false:postOfficeCorrState}
        value={sameAddress ? postOffice : coresPostOffice || ""}
        setState={setCoresPostOffice}
        setError={sameAddress?false:setPostOfficeCorrState}
        disabled={sameAddress || loanStatus ? true : !editable || (disabledFields && (postOffice || coresPostOffice))}
        id="post_office"
        />
    </Grid>
      <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
      <CustomeTextField
        label="Village/Town/City"
        required
        type="alphabets"
        error={sameAddress ?false:villageTownCityCorrState}
        value={sameAddress ? villageTownCity : coresVillage || ""}
        setState={setCoresVillage}
        setError={sameAddress?false:setVillageTownCityCorrState}
        disabled={sameAddress || loanStatus ? true : !editable || (disabledFields && (villageTownCity || coresVillage)) }
        id="village_toen"
        />
    </Grid>
    <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
    {sameAddress || disabledScreen || !editable || (disabledFields && stateName) ? (
    <CustomeTextField
        label="State"
        required
        value={stateName || ""}
        disabled={true}
        id="state"
    />
) : (
    <CustomeSelectNew
        label="State*"
        error={sameAddress ? false : stateNameCorrState}
        value={sameAddress ? stateName : coresState || ""}
        setState={setCoresState}
        data={stateList}
        setError={sameAddress ? false : setStateNameCorrState}
        type="name"
        disabled={!editable || loanStatus}
        id="state"
    />
)}
     </Grid>
     <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
      <CustomeTextField
        label="District"
        required
        type="alphabets"
        error={sameAddress ?false:districtCorrState}
        value={sameAddress ? district : coresDistrict || ""}
        setState={setCoresDistrict}
        setError={sameAddress?false:setDistrictCorrState}
        disabled={sameAddress || loanStatus ? true : !editable ||  (disabledFields && (district || coresDistrict))}
        id="district"
        />
    </Grid>
    <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
      <CustomeTextField
        label="Pincode"
        required
        type="digits"
        error={sameAddress ?false:pincodeCorrState}
        value={sameAddress ? pincode : coresPinCode || ""}
        setState={setCoresPinCode}
        setError={sameAddress?false:setPincodeCorrState}
        maxLength="6"
        id="pincode"
        disabled={sameAddress || loanStatus ? true : !editable ||  (disabledFields && (pincode || coresPinCode)) }
        />
    </Grid>
  </Grid>
  </Grid>
    );
};

CorrespondenceAddress.propTypes = {
  sameAddress: bool,
  correspondenceError:object,
  correspondenceSuccess: object,
  inputFields: object,
  handleInput: object,
  houseNumber: string,
  editable: bool,
  street: string,
  locality: string,
  postOffice: string,
  villageTownCity: string,
  stateName: string,
  stateList: array,
  district: string,
  pincode: string,
  classes: object,
};

export default CorrespondenceAddress;